import { ColDef } from 'ag-grid-community';
import { CommonCodeColumn, getCommonCodeColumnOptions } from 'src/utils/grid/GridColumnContent';
import { SysCodeDto } from 'src/types/base';

// 품목별 재고 컬럼 정의 (ITEM view) - 백엔드와 동일한 15개 컬럼 구조
export const getItemStockColumns = (unitList: SysCodeDto[]): ColDef[] => [
    { headerName: '물류센터', colId: 'logicCenterNm', field: 'logicCenterNm', width: 100, editable: false, hide: true }, // NULL이므로 숨김
    { headerName: '물류센터코드', colId: 'logicCenter', field: 'logicCenter', width: 100, editable: false, hide: true }, // NULL이므로 숨김
    { headerName: '창고코드', colId: 'warehouseCd', field: 'warehouseCd', width: 100, editable: false, hide: true }, // NULL이므로 숨김
    { headerName: '창고명', colId: 'warehouseNm', field: 'warehouseNm', width: 150, editable: false, hide: true }, // NULL이므로 숨김
    { 
        headerName: '품목코드', 
        colId: 'itemCd', 
        field: 'itemCd', 
        width: 120, 
        editable: false,
        cellRenderer: (params: any) => {
            if (params.data?.isSubtotal) {
                return params.data.groupLabel || `${params.data.itemCd} 소계`;
            }
            return params.value || '';
        }
    },
    { headerName: '품명', colId: 'itemNm', field: 'itemNm', width: 220, editable: false },
    { headerName: '규격', colId: 'itemSpec', field: 'itemSpec', width: 150, editable: false },
    { headerName: '보관위치', colId: 'locationNm', field: 'locationNm', width: 120, editable: false },
    { headerName: '등급', colId: 'itemStatus', field: 'itemStatus', width: 80, editable: false, hide: true }, // NULL이므로 숨김
    { headerName: '단위', colId: 'itemUnit', field: 'itemUnit', width: 80, 
		...CommonCodeColumn.options(unitList, false, undefined, undefined), },
    { headerName: '브랜드코드', colId: 'brandCd', field: 'brandCd', width: 100, editable: false },
    { headerName: '브랜드', colId: 'brandNm', field: 'brandNm', width: 120, editable: false },
    { 
        headerName: '현재고', 
        colId: 'stockQty', 
        field: 'stockQty', 
        width: 100, 
        type: 'numericColumn',
        comparator: (valueA, valueB) => valueA - valueB,
        valueFormatter: (p: any) => (p.value ?? 0).toLocaleString(),
        cellRenderer: (params: any) => {
            if (params.data?.isSubtotal) {
                return (params.data.stockQty ?? 0).toLocaleString();
            }
            return params.valueFormatted ?? (params.value ?? '');
        },
        editable: false 
    },
    { 
        headerName: '출고예약', 
        colId: 'reservQty', 
        field: 'reservQty', 
        width: 100, 
        type: 'numericColumn',
        comparator: (valueA, valueB) => valueA - valueB,
        valueFormatter: (p: any) => (p.value ?? 0).toLocaleString(),
        cellRenderer: (params: any) => {
            if (params.data?.isSubtotal) {
                return (params.data.reservQty ?? 0).toLocaleString();
            }
            return params.valueFormatted ?? (params.value ?? '');
        },
        editable: false 
    },
    { 
        headerName: '가용재고', 
        colId: 'availableQty', 
        field: 'stockQty', 
        width: 100, 
        type: 'numericColumn',
        comparator: (valueA, valueB) => valueA - valueB,
        valueFormatter: (p: any) => (p.value ?? 0).toLocaleString(),
        editable: false 
    },
];

// 창고별 재고 컬럼 정의 (WAREHOUSE view) - 백엔드와 동일한 15개 컬럼 구조
export const getWarehouseStockColumns = (unitList: SysCodeDto[]): ColDef[] => [
    { headerName: '물류센터', colId: 'logicCenterNm', field: 'logicCenterNm', width: 100, editable: false },
    { headerName: '물류센터코드', colId: 'logicCenter', field: 'logicCenter', width: 100, editable: false },
    { headerName: '창고코드', colId: 'warehouseCd', field: 'warehouseCd', width: 100, editable: false },
    { headerName: '창고명', colId: 'warehouseNm', field: 'warehouseNm', width: 150, editable: false },
    { 
        headerName: '품목코드', 
        colId: 'itemCd', 
        field: 'itemCd', 
        width: 120, 
        editable: false,
        cellRenderer: (params: any) => {
            if (params.data?.isSubtotal) {
                return params.data.groupLabel || `${params.data.itemCd} 소계`;
            }
            return params.value || '';
        }
    },
    { headerName: '품명', colId: 'itemNm', field: 'itemNm', width: 220, editable: false },
    { headerName: '규격', colId: 'itemSpec', field: 'itemSpec', width: 150, editable: false },
    { headerName: '보관위치', colId: 'locationNm', field: 'locationNm', width: 120, editable: false },
    { headerName: '등급', colId: 'itemStatus', field: 'itemStatus', width: 80, editable: false },
    { headerName: '단위', colId: 'itemUnit', field: 'itemUnit', width: 80, 
		...CommonCodeColumn.options(unitList, false, undefined, undefined), },
    { headerName: '브랜드코드', colId: 'brandCd', field: 'brandCd', width: 100, editable: false },
    { headerName: '브랜드', colId: 'brandNm', field: 'brandNm', width: 120, editable: false },
    { 
        headerName: '현재고', 
        colId: 'stockQty', 
        field: 'stockQty', 
        width: 100, 
        type: 'numericColumn',
        comparator: (valueA, valueB) => valueA - valueB,
        valueFormatter: (p: any) => (p.value ?? 0).toLocaleString(),
        cellRenderer: (params: any) => {
            if (params.data?.isSubtotal) {
                return (params.data.stockQty ?? 0).toLocaleString();
            }
            return params.valueFormatted ?? (params.value ?? '');
        },
        editable: false 
    },
    { 
        headerName: '출고예약', 
        colId: 'reservQty', 
        field: 'reservQty', 
        width: 100, 
        type: 'numericColumn',
        comparator: (valueA, valueB) => valueA - valueB,
        valueFormatter: (p: any) => (p.value ?? 0).toLocaleString(),
        cellRenderer: (params: any) => {
            if (params.data?.isSubtotal) {
                return (params.data.reservQty ?? 0).toLocaleString();
            }
            return params.valueFormatted ?? (params.value ?? '');
        },
        editable: false 
    },
    { 
        headerName: '가용재고', 
        colId: 'availableQty', 
        field: 'stockQty', 
        width: 100, 
        type: 'numericColumn',
        comparator: (valueA, valueB) => valueA - valueB,
        valueFormatter: (p: any) => (p.value ?? 0).toLocaleString(),
        editable: false 
    },
];

// 물류센터별 재고 컬럼 정의 (CENTER view) - 백엔드와 동일한 15개 컬럼 구조
export const getLogicCenterStockColumns = (unitList: SysCodeDto[]): ColDef[] => [
    { headerName: '물류센터', colId: 'logicCenterNm', field: 'logicCenterNm', width: 200, editable: false },
    { headerName: '물류센터코드', colId: 'logicCenter', field: 'logicCenter', width: 100, editable: false },
    { headerName: '창고코드', colId: 'warehouseCd', field: 'warehouseCd', width: 100, editable: false },
    { headerName: '창고명', colId: 'warehouseNm', field: 'warehouseNm', width: 150, editable: false },
    { 
        headerName: '품목코드', 
        colId: 'itemCd', 
        field: 'itemCd', 
        width: 120, 
        editable: false,
        cellRenderer: (params: any) => {
            if (params.data?.isSubtotal) {
                return params.data.groupLabel || `${params.data.itemCd} 소계`;
            }
            return params.value || '';
        }
    },
    { headerName: '품명', colId: 'itemNm', field: 'itemNm', width: 220, editable: false },
    { headerName: '규격', colId: 'itemSpec', field: 'itemSpec', width: 150, editable: false },
    { headerName: '보관위치', colId: 'locationNm', field: 'locationNm', width: 120, editable: false },
    { headerName: '등급', colId: 'itemStatus', field: 'itemStatus', width: 80, editable: false },
    { headerName: '단위', colId: 'itemUnit', field: 'itemUnit', width: 80, 
		...CommonCodeColumn.options(unitList, false, undefined, undefined), },
    { headerName: '브랜드코드', colId: 'brandCd', field: 'brandCd', width: 100, editable: false },
    { headerName: '브랜드', colId: 'brandNm', field: 'brandNm', width: 120, editable: false },
    { 
        headerName: '현재고', 
        colId: 'stockQty', 
        field: 'stockQty', 
        width: 120, 
        type: 'numericColumn', 
        comparator: (valueA, valueB) => valueA - valueB,
        valueFormatter: (p: any) => (p.value ?? 0).toLocaleString(),
        cellRenderer: (params: any) => {
            if (params.data?.isSubtotal) {
                return (params.data.stockQty ?? 0).toLocaleString();
            }
            return params.valueFormatted ?? (params.value ?? '');
        },
        editable: false 
    },
    { 
        headerName: '출고예약', 
        colId: 'reservQty', 
        field: 'reservQty', 
        width: 100, 
        type: 'numericColumn', 
        comparator: (valueA, valueB) => valueA - valueB,
        valueFormatter: (p: any) => (p.value ?? 0).toLocaleString(),
        cellRenderer: (params: any) => {
            if (params.data?.isSubtotal) {
                return (params.data.reservQty ?? 0).toLocaleString();
            }
            return params.valueFormatted ?? (params.value ?? '');
        },
        editable: false 
    },
    { 
        headerName: '가용재고', 
        colId: 'availableQty', 
        field: 'stockQty', 
        width: 100, 
        type: 'numericColumn', 
        comparator: (valueA, valueB) => valueA - valueB,
        valueFormatter: (p: any) => (p.value ?? 0).toLocaleString(),
        editable: false 
    },
];

// 전체 재고 컬럼 정의 (ALL view) - 백엔드와 동일한 15개 컬럼 구조
export const getTotalStockColumns = (unitList: SysCodeDto[]): ColDef[] => [
    { headerName: '물류센터', colId: 'logicCenterNm', field: 'logicCenterNm', width: 150, editable: false },
    { headerName: '물류센터코드', colId: 'logicCenter', field: 'logicCenter', width: 100, editable: false },
    { headerName: '창고코드', colId: 'warehouseCd', field: 'warehouseCd', width: 100, editable: false },
    { headerName: '창고명', colId: 'warehouseNm', field: 'warehouseNm', width: 120, editable: false },
    { headerName: '품목코드', colId: 'itemCd', field: 'itemCd', width: 120, editable: false },
    { headerName: '품명', colId: 'itemNm', field: 'itemNm', width: 220, editable: false },
    { headerName: '규격', colId: 'itemSpec', field: 'itemSpec', width: 150, editable: false },
    { headerName: '보관위치', colId: 'locationNm', field: 'locationNm', width: 120, editable: false },
    { headerName: '등급', colId: 'itemStatus', field: 'itemStatus', width: 80, editable: false },
    { headerName: '단위', colId: 'itemUnit', field: 'itemUnit', width: 80, ...CommonCodeColumn.options(unitList, false, undefined, undefined), },
    { headerName: '브랜드코드', colId: 'brandCd', field: 'brandCd', width: 100, editable: false },
    { headerName: '브랜드', colId: 'brandNm', field: 'brandNm', width: 120, editable: false },
    { headerName: '현재고', colId: 'stockQty', field: 'stockQty', width: 100, type: 'numericColumn', comparator: (valueA, valueB) => valueA - valueB, valueFormatter: (p: any) => (p.value ?? 0).toLocaleString(), editable: false },
    { headerName: '출고예약', colId: 'reservQty', field: 'reservQty', width: 100, type: 'numericColumn', comparator: (valueA, valueB) => valueA - valueB, valueFormatter: (p: any) => (p.value ?? 0).toLocaleString(), editable: false },
    { 
        headerName: '가용재고', 
        colId: 'availableQty', 
        field: 'stockQty', // 필드는 availableQty로 유지
        width: 100, 
        type: 'numericColumn', comparator: (valueA, valueB) => valueA - valueB, valueFormatter: (p: any) => (p.value ?? 0).toLocaleString(),
        editable: false 
    },
];

// 탭별 그리드 옵션 - 최종 옵션으로 통일
export const getTabGridOptions = () => ({
    ensureDomOrder: true,
    suppressRowHoverHighlight: true,
    // suppressCellFocus: true, << 잠그지 말것
    pagination: false,
    maxBlocksInCache: 10,
    blockLoadDebounceMillis: 100,
    suppressBrowserResizeObserver: true,
    suppressPropertyNamesCheck: true,
    debounceVerticalScrollbar: true,
    debounceHorizontalScrollbar: true,
    suppressCellChangeFlash: true,
});
